/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarExclamation} from '@fortawesome/pro-duotone-svg-icons';

const EndOfYearIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCalendarExclamation} {...props} />
);

export default EndOfYearIcon;
